import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import Footer from "../../components/footer";
import ModuleHeader from "../../components/moduleHeader";
import { useEffect } from "react";
import { getProfile } from "../../services/api";
import { useState } from "react";
import { deleteToken } from "../../services/cookies";

function Settings() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);
  const { id: uuid } = useParams();
  
  const fetchProfile = async () => {
    const response = await getProfile();
    setData(response);
  };

  const handleLogout = async () => {
    await deleteToken("jodiactoken");
    navigate("/" + uuid + "/login");
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const userData = {
    fullName: data && data.user ? data.user.first_name + " " + data.user.last_name : "",
    profileImage: data && data.user ? data.user.pictureDetails ? data.user.pictureDetails.url : "/assets/pngImages/user.png" : "/assets/pngImages/user.png",
    birthDate: "30 Ocak, 2003",
    zodiacSign: "Aslan",
  };

  return (
    <div className="w-full h-screen min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed] relative">
      <div className="flex flex-col items-center w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto">
        {/* ModuleHeader */}
        <div className="relative z-30 w-full mb-2">
          <ModuleHeader
            userName={userData.fullName}
            subtitle="Ayarlar Modülüne Hoş Geldiniz"
            title="Ayarlar"
            description="Profil bilgilerinizi düzenleyin, hesap ayarlarınızı yönetin ve uygulama tercihlerinizi kişiselleştirin."
            backgroundImage="/assets/settings.jpg"
            onExpandedChange={setIsHeaderExpanded}
            showToggle={true}
            autoHeight={true}
          />
        </div>

        <div className="w-full px-6 pb-20">
          <div className="flex flex-col gap-0.5 pt-4">
              <Link to="profile" className="bg-white hover:bg-gray-100 transition-colors duration-300 flex flex-row justify-between items-center w-full p-4 rounded-xl">
                <div className="flex flex-row items-center">
                  <img
                    src="/assets/profilePageImages/editProfileImg.png"
                    alt=""
                    className="w-[24px] h-[24px]"
                  />
                  <h1 className="text-[14px] font-poppins text-gray-900 ml-3">
                    Profili Düzenle
                  </h1>
                </div>
                <div className="text-gray-900">
                  <IoIosArrowForward className="text-md" />
                </div>
              </Link>
              
              <Link to="token-balance" className="bg-white hover:bg-gray-100 transition-colors duration-300 flex flex-row justify-between items-center w-full p-4 rounded-xl">
                <div className="flex flex-row items-center">
                  <img
                    src="/assets/profilePageImages/buyProfileImg.png"
                    alt=""
                    className="w-[24px] h-[24px]"
                  />
                  <h1 className="text-[14px] font-poppins text-gray-900 ml-3">
                    JT Bakiyem
                  </h1>
                </div>
                <div className="text-gray-900">
                  <IoIosArrowForward className="text-md" />
                </div>
              </Link>
              
              <Link to={`/${uuid}/store`} className="bg-white hover:bg-gray-100 transition-colors duration-300 flex flex-row justify-between items-center w-full p-4 rounded-xl">
                <div className="flex flex-row items-center">
                  <img
                    src="/assets/icons/shopping.png"
                    alt=""
                    className="w-[24px] h-[24px]"
                  />
                  <h1 className="text-[14px] font-poppins text-gray-900 ml-3">
                    Mağaza
                  </h1>
                </div>
                <div className="text-gray-900">
                  <IoIosArrowForward className="text-md" />
                </div>
              </Link>
              
              <Link to="support" className="bg-white hover:bg-gray-100 transition-colors duration-300 flex flex-row justify-between items-center w-full p-4 rounded-xl">
                <div className="flex flex-row items-center">
                  <img
                    src="/assets/profilePageImages/supportProfileImg.png"
                    alt=""
                    className="w-[24px] h-[24px]"
                  />
                  <h1 className="text-[14px] font-poppins text-gray-900 ml-3">
                    Destek
                  </h1>
                </div>
                <div className="text-gray-900">
                  <IoIosArrowForward className="text-md" />
                </div>
              </Link>
              
              <button
                onClick={handleLogout}
                className="bg-white hover:bg-gray-100 transition-colors duration-300 mb-14 flex flex-row justify-between items-center w-full p-4 rounded-xl"
              >
                <div className="flex flex-row items-center">
                  <img
                    src="/assets/profilePageImages/logoutProfileImg.png"
                    alt=""
                    className="w-[24px] h-[24px]"
                  />
                  <h1 className="text-[14px] font-poppins text-[#FF5648] ml-3">
                    Çıkış Yap
                  </h1>
                </div>
                <div className="text-[#FF5648]">
                  <IoIosArrowForward className="text-md" />
                </div>
              </button>
          </div>
        </div>
        
        <Footer uuid={uuid} />
      </div>
    </div>
  );
}

export default Settings;